import { NgModule } from '@angular/core';
import { MediaBrowserModalService } from './media-browser.service';
import { MediaBrowserModalComponent } from './media-browser-modal.component';

import { MediaBrowserModule } from '@schoolbelle/shared/components';
import 'hammerjs';

@NgModule({
  imports: [
    MediaBrowserModule
  ],
  providers:[MediaBrowserModalService],
  declarations: [MediaBrowserModalComponent],
  entryComponents: [MediaBrowserModalComponent],
})
export class MediaBrowserModalModule { }